import React from "react";
import { Box, Typography, SxProps, Theme } from "@mui/material";
import __ from "src/utils/Translations";

export interface ErrorData {
  correlationId: string;
  date: string;
  type: string;
  sx?: SxProps<Theme>;
}

const DetailRow = ({ label, value }: { label: string; value: string }) => (
  <Typography variant="body1">
    <Typography component="span" sx={{ fontWeight: 700 }}>
      {label}:{" "}
    </Typography>
    <Typography component="span" sx={{ fontWeight: 400 }}>
      {value}
    </Typography>
  </Typography>
);

const ErrorDetails: React.FC<ErrorData> = ({
  correlationId,
  date,
  type,
  sx,
}) => (
  <Box
    sx={{
      background: "#FAFAFA",
      borderRadius: 2,
      padding: "8px 24px",
      textAlign: "left",
      maxWidth: "500px",
      width: "100%",
      mt: 3,
      ...((sx as object) || {}),
    }}
  >
    <DetailRow label={`${__("CorrelationId")}`} value={correlationId} />
    <DetailRow label={`${__("Data")}`} value={date} />
    <DetailRow label={`${__("Typ")}`} value={type} />
  </Box>
);

export default ErrorDetails;
